import { fetchWrapper } from 'app/_helpers/fetch-wrapper';

const WMSInbondURL = process.env.REACT_APP_API_WMSINBOUND_URL;
const baseUrl = `${WMSInbondURL}advice`;

export const AdviceService = {
    getAll,
    getById,
    create,
    createFormData,
    updateFormData,
    getByIdAdviceStatusId,
    update,
    delete: _delete,
    getAllRto,
    download,
};

function getAll(clientId) {
    return fetchWrapper.get(`${baseUrl}/client/${clientId}`);
}

function getByIdAdviceStatusId(id) {
    return fetchWrapper.get(`${baseUrl}/status-id?id=${id}`);
}
function getById(id) {
    return fetchWrapper.get(`${baseUrl}/${id}`);
}

function create(params) {
    return fetchWrapper.post(baseUrl, params);
}

function createFormDataOld(params) {
    return fetchWrapper.post(`${baseUrl}/upload/create-master`, params);
}
function createFormData(params) {
    return fetchWrapper.post(`${WMSInbondURL}customer-portal/upload/create-master`, params);
}
function updateFormData(params, id) {
    return fetchWrapper.put(`${baseUrl}/upload/create-master/${id}`, params);
}

function update(id, params) {
    return fetchWrapper.put(`${baseUrl}/${id}`, params);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(id) {
    return fetchWrapper.delete(`${baseUrl}/${id}`);
}

function getAllRto(clientId) {
    return fetchWrapper.get(`${baseUrl}/client/${clientId}/rto`);
}

function download(path, name) {
    return fetchWrapper.get(`${WMSInbondURL}/file/download?fileName=${path}`);
}